window.theme = window.theme || {};

theme.config = {
    mediaQueries: {
      belowTablet: 'screen and (max-width: 768px)',
      tablet: 'screen and (min-width: 769px)',
      belowLaptop: 'screen and (max-width: 1140px)',
      laptop: 'screen and (min-width: 1141px)',
      belowDesktop: 'screen and (max-width: 1024px)',
      desktop: 'screen and (min-width: 1025px)',
      belowWidescreen: 'screen and (max-width: 1280px)',
      widescreen: 'screen and (min-width: 1281px)',
      belowExtrawide: 'screen and (max-width: 1440px)',
      extrawide: 'screen and (min-width: 1441px)'
    }
};